import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Spacing } from '@app/shared/types';

interface LinkOptions {
  label: string;
  route: string;
}

@Component({
  selector: 'app-secondary-navigation',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './secondary-navigation.component.html',
  styleUrl: './secondary-navigation.component.css',
})
export class SecondaryNavigationComponent implements OnChanges, OnInit {
  @Input() links: Array<LinkOptions>;
  @Input() limit = 8;
  @Input() spacingBottom = Spacing.LARGE;

  current = 0;
  tabs = new Array<LinkOptions>();
  showRightArrow = true;
  ngOnInit(): void {
    this.tabs = this.setTabs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['links'] && changes['links'].currentValue) {
      this.tabs = this.setTabs();
    }
  }
  scrollRight(event: Event) {
    event.preventDefault();
    if (this.current < this.links.length - this.limit) {
      this.current = Math.min(this.current + this.limit, this.links.length);
    } else {
      this.current = 0;
    }
    this.tabs = this.setTabs();
  }

  scrollLeft(event: Event) {
    event.preventDefault();
    if (this.current > 0) {
      this.current = Math.max(this.current - this.limit, 0);
    } else {
      this.current = Math.max(this.links.length - this.limit, 0);
    }
    this.tabs = this.setTabs();
  }

  setTabs(): LinkOptions[] {
    const result: LinkOptions[] = [];
    const selectionsLength = this.links.length - this.current;
    const itemsToDisplay = Math.min(this.limit, selectionsLength);
    for (let i = 0; i < itemsToDisplay; i++) {
      result.push(this.links[this.current + i]);
    }
    if (result.length < this.limit) {
      this.showRightArrow = false;
    } else {
      this.showRightArrow = true;
    }
    return result;
  }
}
